//  Base form component
// ====================

import React from 'react'
import PropTypes from 'prop-types'
import style from './form.scss'
import cx from 'classnames'

export default class Form extends React.Component {
  render() {
    const {
      onSubmit,
      id,
      action,
      children,
      className,
      ...restProps
    } = this.props

    const classNames = cx(style.Form, className)

    return (
      <form
        className={classNames}
        onSubmit={onSubmit}
        id={id}
        action={action}
        {...restProps}
      >
        {children}
      </form>
    )
  }
}

Form.propTypes = {
  action: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  onSubmit: PropTypes.func,
  children: PropTypes.node,
}
